(function () {
  var el = document.getElementById("retail-reward-bar");
  if (!el) return; // not rendered (affiliate or missing) → do nothing

  // Mirrors MARKET in the discount Function (extensions/retail-customer-discount/src/reward.js).
  // The presentment currency identifies the store: Global enables only USD, Mexico only MXN.
  // `rate` converts presentment back to the USD thresholds at the fixed 18:1 catalog ratio —
  // NOT the daily FX rate, which settles near 16.95 and would light tiers ~6% early.
  // `tiers` are ordered LOW to HIGH here (the Function orders them high-first).
  // Keep both tables in step: if they disagree, the bar lies about what checkout will do.
  var MARKET = {
    USD: { rate: 1, tiers: [{ min: 300, rate: 0, ship: true }] },
    MXN: { rate: 18, tiers: [
      { min: 200, rate: 10, ship: false },
      { min: 250, rate: 25, ship: false },
      { min: 300, rate: 25, ship: true },
    ] },
  };

  var membershipId = el.getAttribute("data-membership-variant-id") || "";
  var packIds = (el.getAttribute("data-pack-variant-ids") || "")
    .split(",").map(function (s) { return s.trim(); }).filter(Boolean);

  function marketOf(cart) {
    var code = String(
      (cart && cart.currency) ||
      (window.Shopify && Shopify.currency && Shopify.currency.active) || ""
    ).toUpperCase();
    return MARKET[code] ? { code: code, m: MARKET[code] } : null;
  }

  function isPack(item) {
    var p = item.properties || {};
    if (p._bbg_builder === "1" || (p._bundle_pack != null && p._bundle_pack !== "")) return true;
    // Fallback for packs added straight from a product page (no _bundle_pack tag).
    return packIds.indexOf(String(item.variant_id)) !== -1;
  }
  function isMembership(item) {
    return membershipId && String(item.variant_id) === String(membershipId);
  }
  // Seal "Subscribe & Save" items carry a native selling-plan allocation.
  // The reward is one-time-purchase only, so any subscription line voids it.
  function isSubscription(item) {
    return !!item.selling_plan_allocation;
  }

  /**
   * @returns {{spent:number, tiers:Array, code:string, rate:number}|null|undefined}
   *   null      → reward paused by a pack / membership / subscription line
   *   undefined → currency not in the table; the bar hides itself
   * spent and every tier threshold are in the PRESENTMENT currency, so the amounts
   * shown are the amounts the shopper actually has to spend.
   */
  function state(cart) {
    var found = marketOf(cart);
    // Fail closed, exactly as the Function does. Guessing a rate here would promise
    // a reward the Function will not honour.
    if (!found) return undefined;

    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (isPack(items[i]) || isMembership(items[i]) || isSubscription(items[i])) return null;
    }
    var cents = 0;
    for (var j = 0; j < items.length; j++) cents += items[j].final_line_price;

    var rate = found.m.rate;
    var tiers = found.m.tiers.map(function (t) {
      return { at: t.min * rate, rate: t.rate, ship: t.ship };
    });
    return { spent: cents / 100, tiers: tiers, code: found.code, rate: rate };
  }

  function fmtMoney(amount, code) {
    var n = Math.max(0, Math.ceil(amount));
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency", currency: code, maximumFractionDigits: 0,
      }).format(n);
    } catch (e) { return "$" + n; }
  }

  // Visitor-facing words come from data-i18n-* on #retail-reward-bar (snippets/retail-reward-bar.liquid, the store's
  // language); [p] = percent, [x] = amount, [label] = reward label. The English here is the fallback.
  function tx(key, fallback, vars) {
    var s = el.getAttribute("data-i18n-" + key) || fallback;
    Object.keys(vars || {}).forEach(function (k) { s = s.replace("[" + k + "]", function () { return vars[k]; }); });
    return s;
  }
  function rewardLabel(t) {
    if (t.rate && t.ship) return tx("off-ship", "[p]% off + free shipping", { p: t.rate });
    if (t.rate) return tx("off", "[p]% off", { p: t.rate });
    return tx("ship", "free shipping");
  }
  // Caption shown inside a segment. Title case because it reads as a label, not prose.
  function segLabel(t) {
    if (t.rate && t.ship) return tx("seg-off-ship", "[p]% off + Free Shipping", { p: t.rate });
    if (t.rate) return tx("off", "[p]% off", { p: t.rate });
    return tx("seg-ship", "Free Shipping");
  }

  // Each tier band gets an equal slice of the rail, so the milestone ticks are evenly
  // spaced instead of bunching up at the top (3,600 / 4,500 / 5,400 would sit at 67% /
  // 83% / 100% on a linear scale). Single-tier markets are just linear.
  function pct(s) {
    var n = s.tiers.length;
    if (s.spent <= 0) return 0;
    var top = s.tiers[n - 1].at;
    if (s.spent >= top) return 100;
    var slice = 100 / n;
    for (var i = 0; i < n; i++) {
      if (s.spent < s.tiers[i].at) {
        var lo = i === 0 ? 0 : s.tiers[i - 1].at;
        return i * slice + ((s.spent - lo) / (s.tiers[i].at - lo)) * slice;
      }
    }
    return 100;
  }

  // Build the skeleton once so the fill element persists across cart updates — that
  // lets the CSS width transition animate rather than snap.
  // Multi-tier markets render the ladder AS the bar: one segment per reward, each
  // carrying its own caption. Single-tier markets (Global) keep the thin rail, where
  // the message alone already names the only reward.
  function ensureStructure(tiers) {
    var n = tiers.length;
    if (el.__rrbShape === n) return;
    if (n > 1) {
      var segs = "";
      for (var i = 0; i < n; i++) {
        segs += '<div class="rrb__seg">' +
                  '<span class="rrb__seg-fill"></span>' +
                  '<span class="rrb__seg-label">' + segLabel(tiers[i]) + "</span>" +
                "</div>";
      }
      el.innerHTML =
        '<div class="rrb__inner">' +
          '<div class="rrb__head"></div>' +
          '<div class="rrb__segs">' + segs + "</div>" +
        "</div>";
    } else {
      el.innerHTML =
        '<div class="rrb__inner">' +
          '<div class="rrb__head"></div>' +
          '<div class="rrb__rail"><div class="rrb__fill"></div></div>' +
        "</div>";
    }
    el.__rrbShape = n;
  }

  function render(s) {
    if (s === undefined) { el.hidden = true; el.className = "rrb rrb--off"; return; }
    el.hidden = false;

    if (s === null) {
      ensureStructure([{}]);
      el.className = "rrb rrb--paused";
      el.querySelector(".rrb__head").innerHTML =
        "<span>" + tx("paused", "<b>Retail reward paused.</b> One-time purchases only.") + "</span>";
      var pf = el.querySelector(".rrb__fill");
      if (pf) pf.style.width = "0%";
      return;
    }

    ensureStructure(s.tiers);
    var head = el.querySelector(".rrb__head");

    var current = null, next = null;
    for (var i = 0; i < s.tiers.length; i++) {
      if (s.spent >= s.tiers[i].at) current = s.tiers[i];
      else { next = s.tiers[i]; break; }
    }

    var msg;
    if (!current) {
      msg = tx("spend-more", "Spend <b>[x]</b> more to unlock", { x: fmtMoney(next.at - s.spent, s.code) });
    } else if (next) {
      msg = tx("unlocked-next", "<b>[label]</b> unlocked — <b>[x]</b> to the next",
               { label: rewardLabel(current), x: fmtMoney(next.at - s.spent, s.code) });
    } else {
      msg = tx("unlocked", "<b>[label]</b> unlocked!", { label: rewardLabel(current) });
    }
    el.className = "rrb" + (current && !next ? " rrb--won" : "");
    head.innerHTML = (current ? "🎉 " : "🚚 ") + "<span>" + msg + "</span>";

    var segs = el.querySelectorAll(".rrb__seg");
    if (segs.length) {
      for (var k = 0; k < segs.length; k++) {
        var lo = k === 0 ? 0 : s.tiers[k - 1].at;
        var hi = s.tiers[k].at;
        var done = s.spent >= hi;
        // Progress only paints inside the segment being worked on. A completed
        // segment flips to a solid chip instead, so its caption keeps contrast.
        var w = done ? 100 : (s.spent > lo ? ((s.spent - lo) / (hi - lo)) * 100 : 0);
        segs[k].classList[done ? "add" : "remove"]("is-on");
        segs[k].classList[!done && s.spent > lo ? "add" : "remove"]("is-current");
        segs[k].querySelector(".rrb__seg-fill").style.width = (done ? 100 : w).toFixed(1) + "%";
      }
      return;
    }

    // Single-tier markets: the original thin rail.
    var fill = el.querySelector(".rrb__fill");
    var target = (s.spent / s.tiers[0].at) * 100;
    if (s.spent > 0 && target < 3) target = 3;
    if (next && target > 99) target = 99;
    if (target > 100) target = 100;
    fill.style.width = target.toFixed(1) + "%";
  }

  function refresh() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(state(cart)); })
      .catch(function () {});
  }

  // Re-evaluate after any cart mutation (theme-agnostic: patch fetch to /cart/*).
  var origFetch = window.fetch;
  window.fetch = function () {
    var p = origFetch.apply(this, arguments);
    try {
      var url = (arguments[0] && arguments[0].url) || arguments[0] || "";
      if (typeof url === "string" && /\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(refresh, 150); });
      }
    } catch (e) {}
    return p;
  };
  document.addEventListener("DOMContentLoaded", refresh);
  refresh();
})();
